/**
 * Helper: GraphQL
 * -----------------------------------------------------------------------------
 * Handles GraphQL responses.
 * - Add in alphabetical order.
 *
 */

/**
 * Decodes Shopify API IDs into Liquid format IDs.
 * @param {String} string - Encoded string.
 * @returns {String}
 */
export function decodeApiId(string) {
  if (!string) {
    return null;
  }

  return Number(string.split('/').pop());
}

/**
 * Transforms Shopify ID into an API ID.
 * @param {Number} id - Resource ID.
 * @param {String} resource - API resource.
 * @returns {String}
 */
export function transformId(id, resource) {
  if (!id || !resource) {
    return null;
  }

  return `gid://shopify/${resource}/${id}`;
}

/**
 * Removes edges and nodes from GraphQL data.
 * @param {Object} object - GraphQL data.
 * @param {String} field - Optional string to filter by.
 * @returns {Object}
 */
export function transformEdges(object, field) {
  if (!object) {
    return [];
  }

  if (!field) {
    return object.edges.map((edge) => {
      return edge.node;
    });
  }

  return object.edges.map((edge) => {
    return edge.node[field];
  });
}

/**
 * Remove edges from the list of edges.
 * - Used to remove null nodes from the edges.
 * @param {Array} edges - List of edges.
 * @returns {Array} - List of nodes without nulls.
 */
export function removeEdges(edges) {
  return edges
    .flatMap((item) => item.references.edges.map((edge) => edge.node))
    .filter((node) => node !== null);
}
